import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TCITenantSelectorType, TCI_APP_DETAIL_MENU_TYPE } from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../ng-tenant/tci-tenant-component";
import { TCITenantMenuServices } from "../../../ng-tenant/tci-tenant.menu";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_DESIGNER.toString(),
    template: "<ng-iframe class='iFrameContent' [(sanitizedUrl)]='sanitizedUrl' (output)='reactOutput($event)'></ng-iframe>"
})
export class BaseAppDetailDesignerComponent
    <E, I extends BaseAppDetailMenuComponentInput, O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit {

    iFrameUrl: string;
    sanitizedUrl: SafeResourceUrl;

    constructor(
        protected sanitize: DomSanitizer,
        protected tenantMenuSrv: TCITenantMenuServices
    ) {
        super();
    }

    ngOnInit(): void {
        // Prepare the preload map data
        this.tenantMenuSrv
            .getAppDetailMenuItems(this.input.application.type, TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU)
            .subscribe(() => this.getUrl());
    }

    protected getSuffix(): string {
        const preloadMap = this.tenantMenuSrv.getTenantPreloadMap(this.input.application.type);
        const preloadMapData = preloadMap[TCITenantSelectorType.TCI_APP_DETAIL_DESIGNER.toString()];
        if (preloadMapData && preloadMapData.externUrlSuffix) {
            return preloadMapData.externUrlSuffix;
        } else {
            throw Error("No 'externUrlSuffix' data found in preloadMap for 'Designer' component");
        }
    }

    protected getPrefix(): string {
        return this.input.application.info.externalUrl;
    }

    getUrl() { // Form the path using some "path" tool
        const url = new URL(this.getSuffix(), this.getPrefix());
        console.log("Designer iFrame url:", url.toString());
        this.sanitizedUrl = this.sanitize.bypassSecurityTrustResourceUrl(url.toString());
    }

    reactOutput($event: any) {
        console.warn("Reacting to event", $event);
    }
}
